<app-loader></app-loader>
<ng-container *ngIf="isLoginPage">
  <router-outlet></router-outlet>
</ng-container>

<div class="admin-layout" [class.sidebar-mobile-open]="isSidebarOpen" *ngIf="!isLoginPage">
  <app-sidebar [isMobileOpen]="isSidebarOpen" (closeSidebar)="isSidebarOpen = false"></app-sidebar>
  <div class="sidebar-backdrop" *ngIf="isSidebarOpen" (click)="isSidebarOpen = false"></div>

  <div class="main-wrapper">
    <app-header (toggleSidebar)="isSidebarOpen = !isSidebarOpen"></app-header>

    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
